/**
 * Internal hooks for SmartChoice
 * These hooks are implementation details and should not be exported publicly
 */

export { useSmartChoiceContext } from './useSmartChoiceContext';
export { useSmartChoiceFlags } from './useSmartChoiceFlags';
